import React, { Component } from 'react';
import './styles.css';

class TextArea extends Component {
	render() {
		return <textarea maxLength="1000" className="text-area" {...this.props} />;
	}
}

export default TextArea;
